import { makeAutoObservable, toJS } from 'mobx';
import { Connector } from 'wagmi';
import { signMessage, watchAccount } from 'wagmi/actions';
import { apiServiceV2 } from '../../services/apiService';
import { generateMetamaskMessage } from '../../helpers/utils';
import { authorizationStore } from '../../modules/authorization/authorization.store';
import { authDefaultState, wagmiConfig } from './config';

export type TStatus = {
  error: string;
  pending: boolean;
};
export type TConnectOpt = {
  [key: string]: TStatus;
};

class Wagmi {
  pending = false;

  isActive = true;

  connectorName = '';

  isSigned = false;

  connectOpt: TConnectOpt = authDefaultState;

  constructor() {
    makeAutoObservable(this);
  }

  connectConnector = async (connect: any, connector: Connector) => {
    try {
      this.connectorName = connector.name;
      this.connectOpt = {
        ...this.connectOpt,
        [this.connectorName]: {
          error: '',
          pending: true,
        },
      };
      await connect({ connector, chainId: 5165 });
    } catch (error) {
      this.connectOpt = authDefaultState;
    }
  };

  onStatus = (error: any = '', isPending: boolean) => {};

  generateNonceAndSign = async (address: `0x${string}` | undefined) => {
    this.connectOpt = {
      ...this.connectOpt,
      [this.connectorName]: {
        error: '',
        pending: true,
      },
    };

    try {
      const {
        data: { nonce },
      } = await apiServiceV2.generateNonce({
        address,
      });

      const message = generateMetamaskMessage(
        address as string,
        nonce,
        window.location.origin,
      );

      try {
        const signature = await signMessage(wagmiConfig, {
          account: address,
          message,
        });

        const {
          data: { accessToken },
        } = await apiServiceV2.getWalletToken({
          address,
          message,
          signature,
          partnerId: '0',
        });
        authorizationStore.loginWallet(accessToken);
        const unwatch = watchAccount(wagmiConfig, {
          onChange(data) {
            console.log('Account changed!', data);
          },
        });
      } catch (error) {
        console.log(error);
      }
      this.connectOpt = authDefaultState;
    } catch (error) {
      console.error('Error generating signature:', error);
    }
  };
}
export const wagmiStore = new Wagmi();
